/* global gdAlertify */
// En el archivo viejo este modal era una closure anidada dentro del
// componente CalendarioTurnos. Se extrae aquí tal cual: solo depende de sus
// props (isOpen, onClose, onConfirm, row) y de getValorTurnoActual (helper).
import { useState, useEffect } from "react";
import axiosInstance from "../../../config/axiosConfig";
import { formatMoney } from "../../../utils/utils";
import InfoHeader from "./InfoHeader";
import { getValorTurnoActual } from "../helpers";

const DescuentoHorasExtraModal = ({ isOpen, onClose, onConfirm, row }) => {
    const [horas, setHoras] = useState(0);
    const [pagador, setPagador] = useState("auxiliar");
    const [concepto, setConcepto] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (isOpen && row) {
            setHoras(parseInt(row.horasDescuentoExtra || 0, 10));
            const pagadorActual = row.pagadorDescuentoExtra || "auxiliar";
            setPagador(pagadorActual === "sk" ? "auxiliar" : pagadorActual === "paciente" ? "familia" : pagadorActual);
            setConcepto(row.conceptoDescuentoExtra || "");
        }
    }, [isOpen, row]);

    if (!isOpen || !row) return null;

    const valorOriginal = Number(row.valorOriginalDescuentoExtra || 0) > 0
        ? Number(row.valorOriginalDescuentoExtra)
        : getValorTurnoActual(row);
    const baseTurno = Number(row.valorTurnoBase || valorOriginal || 0);
    const valorHora = baseTurno / 12;
    const horasEnteras = parseInt(horas || 0, 10) || 0;
    const valorDescuento = Math.round((horasEnteras * valorHora));
    const aplicaDescuentoCalendario = pagador !== "familia";
    const valorDescuentoCalendario = aplicaDescuentoCalendario ? valorDescuento : 0;
    const valorFinal = aplicaDescuentoCalendario ? Math.max(0, valorOriginal - valorDescuento) : valorOriginal;

    const handleSubmit = (e) => {
        e.preventDefault();
        gdAlertify.confirm({
            title: "Descontar horas",
            message: !aplicaDescuentoCalendario
                ? "El descuento a Familia no modificara las horas ni el valor del turno en el calendario."
                : Number(horas || 0) > 0
                ? `Se descontaran ${horas} hora(s). Valor turno quedara en $ ${formatMoney(valorFinal)}.`
                : "Se quitará el descuento y volverá el valor original.",
            onConfirm: async () => {
                setIsSubmitting(true);
                gdAlertify.showLoader();
                try {
                    const resp = await axiosInstance.post("/turnos/descuento-horas-extra", {
                        pacienteID: row.pacienteID,
                        fecha: row.fecha,
                        periodo: row.tipo,
                        horasDescuento: horasEnteras,
                        valorDescuento: valorDescuentoCalendario,
                        valorTurno: valorFinal,
                        pagador,
                        concepto,
                        es_apoyo: row.es_apoyo,
                    });

                    if (!resp.data.error) {
                        gdAlertify.notiSuccess(resp.data.message);
                        onConfirm({ pacienteID: row.pacienteID, fecha: row.fecha, esRango: false });
                        onClose();
                    } else {
                        gdAlertify.notiError(resp.data.message);
                    }
                } catch (error) {
                    gdAlertify.notiError("Error al conectar con el servidor.");
                } finally {
                    gdAlertify.hideLoader();
                    setIsSubmitting(false);
                }
            },
            onCancel: () => gdAlertify.notify("Cancelado", "error"),
        });
    };

    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="modal-header">
                                <h5 className="modal-title">Descontar Horas</h5>
                                <button type="button" className="btn-close" onClick={onClose} disabled={isSubmitting} />
                            </div>
                            <div className="modal-body">
                                <InfoHeader row={row} />
                                <div className="row g-3 mt-2">
                                    <div className="col-md-6">
                                        <label className="form-label">Horas</label>
                                        <input
                                            type="number"
                                            min="0"
                                            step="1"
                                            className="form-control"
                                            value={horas}
                                            onChange={(e) => setHoras(parseInt(e.target.value || 0, 10))}
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Descuento A:</label>
                                        <select
                                            className="form-select"
                                            value={pagador}
                                            onChange={(e) => setPagador(e.target.value)}
                                            disabled={isSubmitting}
                                        >
                                            <option value="familia">Familia</option>
                                            <option value="auxiliar">Auxiliar</option>
                                            <option value="ambas">Ambas</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <label className="form-label">Concepto / observacion</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={concepto}
                                        onChange={(e) => setConcepto(e.target.value)}
                                        disabled={isSubmitting}
                                        placeholder="Motivo del descuento"
                                    />
                                </div>
                                <div className="alert alert-light border mt-3 mb-0">
                                    <div>Valor original: <b>${formatMoney(valorOriginal)}</b></div>
                                    <div>Descuento turno: <b>${formatMoney(valorDescuentoCalendario)}</b></div>
                                    <div>Valor turno final: <b>${formatMoney(valorFinal)}</b></div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isSubmitting}>Cancelar</button>
                                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DescuentoHorasExtraModal;
